var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.094 18.18h-2.182V9.453h2.182zm0 4.367h-2.182v-2.182h2.182z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    x: 27.25,
    y: 27.25,
    stroke: "currentColor",
    strokeWidth: 1.5,
    opacity: 0.5,
    rx: 11.25,
    transform: "rotate(-180 27.25 27.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f65c907af06b3dffe902153ade54e8e7.svg";
export { ForwardRef as ReactComponent };